import React from 'react'

import clsx from 'clsx'

import ArticleCard from 'components/ArticleCard'
import { EventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import TextBase from '../TextBase'
import ArticleCardLarge from './components/ArticleCardLarge'

import classes from './RelatedArticles.module.scss'

/** @type {import("./types").default} */
const RelatedArticles = ({ className, articles }) => {
  const { down } = useViewport()
  const isMobile = down('md')
  const numberOfCards = isMobile ? 4 : 3
  const highlightedArticle = articles?.items[3] || null

  return (
    <section className={clsx('RelatedArticles', classes.root, className)}>
      <TextBase title="Related articles" />
      <EventContext value={{ engagementComponent: 'related-article' }}>
        <div className={classes.articlesRoot}>
          {articles?.items?.slice(0, numberOfCards).map(post => (
            <ArticleCard key={post.sys.id} post={post} isElevated={false} className={classes.cardItem} />
          ))}
        </div>
      </EventContext>
      {!isMobile && highlightedArticle && <ArticleCardLarge post={highlightedArticle} />}
    </section>
  )
}

export default RelatedArticles
